<template lang="html">
  <section class="m-column" :id="id">
    <div class="m-row">
      <div class="m-column_element">
        <div class="m-column_item">
          {{ getMessageText(messages.ICON_INPUT) }}
        </div>
        <search-box-icons
          :value="iconValue"
          :should-focus="shouldFocus"
          @on-search-box-icon-selected="onIconSelected"
        />
      </div>
    </div>
    <div class="m-row">
      <div class="m-column_element">
        <div class="m-column_item">
          {{ getMessageText(messages.FIELD_LIST_ITEM_LABEL) }}
        </div>
        <expressions
          id="headerField"
          :data-elements="allSources"
          :data-type="'string'"
          :initial-expression="headerFieldValue"
          :is-global="true"
          :content-type="appContent.type"
          @on-expression-field-valid="onConfigExpressionValid"
        />
      </div>
    </div>

    <div class="m-row">
      <div class="m-column_element">
        <div class="m-column_item">
          {{ getMessageText(messages.FIELD_LIST_ITEM_VALUE) }}
        </div>
        <expressions
          id="valueField"
          :data-elements="allSources"
          :data-type="'string'"
          :initial-expression="valueFieldValue"
          :is-global="true"
          :content-type="appContent.type"
          @on-expression-field-valid="onConfigExpressionValid"
        />
      </div>
    </div>
    <div class="m-row" v-if="valueFieldValue">
      <div class="m-column_element">
        <div class="m-column_item"></div>
        <user-action
          :all-sources="allSources"
          :is-global="true"
          :data-type="'string'"
          :action="valueAction"
          :app-id="appId"
          @on-user-action-change="onUserActionChange"
        />
      </div>
    </div>
    <div
      class="m-column_del"
      tabindex="0"
      @keydown.enter.stop="deleteColumn"
      @click="deleteColumn"
    >
      <svg>
        <use :xlink:href="getUtilityIcon('delete')"></use>
      </svg>
    </div>
  </section>
</template>

<script lang="js">
  import store from "@/store";
  import iconsUri from "@/views/drag-drop-pages/components/utils/icons-uri";
  import dragAndDrop from "@/views/drag-drop-pages/components/utils/dragAndDrop";
  import expressionBuilder from "@/views/drag-drop-pages/components/utils/expression-builder";
  import Expressions from "@/components/Expressions"
  import UserAction from "@/views/drag-drop-pages/components/builder/modal/UserAction";
  import SearchBoxIcons from "@/views/drag-drop-pages/components/searchbox/searchicons/SearchBoxIcons";

  export default  {
    name: "field-list-element",
    components: {
      Expressions,
      UserAction,
      SearchBoxIcons
    },
    props: {
      id: {
        type: String
      },
      shouldFocus: {
        type: Boolean
      },
      columnData: {
        type: Object
      }
    },
    computed: {
      messages() {
        return store.state.messages;
      },
      appId() {
        return dragAndDrop.getAppId();
      },
      appContent() {
        return JSON.parse(JSON.stringify(expressionBuilder.getAppContent(this.appId)));
      },
      allSources() {
        let output = null;
        if (this.appContent) {
          output = this.appContent.dataElements || {};
        } else {
          console.error(`No app content found for appId ${this.appId}`);
        }
        return output;
      },
      sourcesList() {
        return expressionBuilder.filterGlobalSources(this.allSources);
      }
    },
    mounted () {
      if(this.columnData.label && this.columnData.value) {
        this.headerFieldValue = this.columnData.label;
        this.valueFieldValue = this.columnData.value;
        this.valueAction = this.columnData.valueAction;
        this.iconValue = this.columnData.icon;
      }
    },
    data () {
      return {
        headerFieldValue: null,
        valueFieldValue: null,
        valueAction: null,
        iconValue: null
      }
    },
    methods: {
      onIconSelected(ctx) {
        this.iconValue = ctx ? ctx.icon : null;
        this.emitEvent();
      },
      onConfigExpressionValid(ctx) {
        if(ctx.id === "headerField") {
          this.headerFieldValue = ctx.status? ctx.confExpression : null;
        } else if(ctx.id === "valueField") {
          this.valueFieldValue = ctx.status? ctx.confExpression : null;
        }
        this.emitEvent();
      },
      getUtilityIcon(iconName) {
        return iconsUri.getUtilityUrl(iconName);
      },
      emitEvent() {
        const obj = {
          id: this.id,
          data: {
            label: this.headerFieldValue,
            value: this.valueFieldValue,
            valueAction: this.valueAction,
            icon: this.iconValue,
          }
        };
        const EVENT = "on-selected-field-column";
        if(this.$listeners[EVENT] || this._events[EVENT]) {
          this.$emit(EVENT, obj);
        }
      },
      deleteColumn() {
        /**
         * Triggers delete event
         */
        const EVENT = "on-delete-column";
        if(this.$listeners[EVENT] || this._events[EVENT]) {
          this.$emit(EVENT, this.columnData);
        }
      },
      onUserActionChange(ctx) {
        this.valueAction = ctx;
        this.emitEvent();
      }
    }
  }
</script>

<style scoped lang="scss">
  @import "@/styles/components/main";
  @include drag-drop-a-tag;
  .m-column {
    @include mixin-box;
    position: relative;
    padding: 20px 12px 0 12px;
    margin-bottom: 4px;
    box-sizing: border-box;
  }
  .m-row {
    margin-bottom: 12px;
  }
  .m-column_element {
    display: grid;
    grid-template-columns: 60px auto 1.2rem;
    grid-template-rows: auto;
    margin-bottom: 10px;
    .m-column_item {
      padding-top: 0.7rem;
    }
  }
  .m-column_del {
    position: absolute;
    top: 0;
    right: 0;
    padding: 0.3rem;
    fill: #c23934;
    cursor: pointer;
    svg {
      height: 18px;
      width: 18px;
    }
  }
</style>
